module.exports = __webpack_public_path__ + "static/L2_ux_1_1_eg-abc0a352cae4d805f0fb7e2f95409161.png";